import { API_CONFIG } from '@/project/configs/api.js'

const BASE = `${API_CONFIG.baseURL}/sidedish`

export default {
  postUrl(payload) {
    console.log('🚀 ~ payload:', payload)
    const { id, action = 'create' } = payload || {}

    // Activation / Désactivation
    if (action === 'activate' && id) {
      return `${BASE}/activate/${id}?group=ultraxeno`
    }
    if (action === 'deactivate' && id) {
      return `${BASE}/deactivate/${id}?group=ultraxeno`
    }

    // Mise à jour (PUT /sidedish/update/{id})
    if (action === 'update' && id) {
      return `${BASE}/update/${id}?group=ultraxeno`
    }
    if (action === 'delete' && id) {
      return `${BASE}/delete/${id}?group=ultraxeno`
    }

    // Création (POST /sidedish/add)
    return `${BASE}/add?group=ultraxeno`
  },

  patchUrl(payload) {
    console.log('🚀 ~ payload:', payload)
    const { id, action = 'create' } = payload || {}

    // Activation / Désactivation
    if (action === 'activate' && id) {
      return `${BASE}/activate/${id}?group=ultraxeno`
    }
    if (action === 'deactivate' && id) {
      return `${BASE}/deactivate/${id}?group=ultraxeno`
    }

    // Mise à jour (PUT /sidedish/update/{id})
    if (action === 'update' && id) {
      return `${BASE}/update/${id}?group=ultraxeno`
    }
    if (action === 'delete' && id) {
      return `${BASE}/delete/${id}?group=ultraxeno`
    }

    // Création (POST /sidedish/add)
    return `${BASE}/add?group=ultraxeno`
  },

  putUrl(payload) {
    console.log('🚀 ~ payload:', payload)
    const { id, action = 'create' } = payload || {}

    // Activation / Désactivation
    if (action === 'activate' && id) {
      return `${BASE}/activate/${id}?group=ultraxeno`
    }
    if (action === 'deactivate' && id) {
      return `${BASE}/deactivate/${id}?group=ultraxeno`
    }

    // Mise à jour (PUT /sidedish/update/{id})
    if (action === 'update' && id) {
      return `${BASE}/update/${id}?group=ultraxeno`
    }
    if (action === 'delete' && id) {
      return `${BASE}/delete/${id}?group=ultraxeno`
    }

    // Création (POST /sidedish/add)
    return `${BASE}/add?group=ultraxeno`
  },

  deleteUrl(payload) {
    console.log('🚀 ~ payload:', payload)
    const { id, action = 'create' } = payload || {}

    // Activation / Désactivation
    if (action === 'activate' && id) {
      return `${BASE}/activate/${id}?group=ultraxeno`
    }
    if (action === 'deactivate' && id) {
      return `${BASE}/deactivate/${id}?group=ultraxeno`
    }

    // Mise à jour (PUT /sidedish/update/{id})
    if (action === 'update' && id) {
      return `${BASE}/update/${id}?group=ultraxeno`
    }
    if (action === 'delete' && id) {
      return `${BASE}/delete/${id}?group=ultraxeno`
    }

    // Création (POST /sidedish/add)
    return `${BASE}/add?group=ultraxeno`
  },

  method(payload) {
    const { action = 'create' } = payload || {}
    if (action === 'activate' || action === 'deactivate') return 'PATCH'
    if (action === 'delete') return 'DELETE'
    if (action === 'update') return 'PUT'
    return 'POST'
  },

  format(payload) {
    const {
      action = 'create',
      data,
      id,
      name,
      description,
      price,
      image,
    } = payload || {}

    // Activation / Désactivation : aucun body
    if (action === 'activate' || action === 'deactivate' || action === 'delete')
      return {}

    const accompaniementData = data || { id, name, description, price, image }

    // Création : tous les champs sont requis
    return {
      name: accompaniementData.name || '',
      description: accompaniementData.description || '',
      price: Number(accompaniementData.price || 0),
      image: accompaniementData.image || '',
      isActive: true,
    }
  },

  parse(raw = {}) {
    // La création retourne 201, les autres opérations retournent 200
    console.log('🚀 ~ raw:', raw)
    if (raw?.statusCode !== 201 && raw?.statusCode !== 200) {
      return {
        statusCode: raw?.statusCode || 500,
        message: raw?.message || 'Le serveur semble innaccessible',
        data: raw?.data || null,
      }
    }

    return {
      statusCode: 200,
      message: raw.message || 'ok',
      data: raw.data || { saved: true },
    }
  },
}
